module.exports = __webpack_public_path__ + "static/media/goldwave_logo.cd921596.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/details/imgs/goldwave_logo.png
// module id = 1157
// module chunks = 0